import React, { ComponentType, useContext } from 'react';
import { AuthContext, Role } from '../../../context/AuthProvider';

function withNotStudentStatus<T>(Component: ComponentType<T>) {
  return (hocProps: T) => {
    const user = useContext(AuthContext);
    if (user?.roles.includes(Role.student) && user?.roles.length === 1) {
      return null;
    }
    return <Component {...hocProps} />;
  };
}

export default withNotStudentStatus;
